import { mountNav } from '../components/Header';
import { register } from '../api/client';

export function RegisterPage(): void {
    const app = document.getElementById('app');
    if (!app) return;

    app.innerHTML = `
        <div class="container">
            <header class="header">
                <h1>Mediabin</h1>
                <nav id="nav"></nav>
            </header>
            <main class="main">
                <h2>Register</h2>
                <form id="register-form">
                    <div class="option-group">
                        <label>Username</label>
                        <input id="username" type="text" minlength="3" maxlength="32" pattern="[a-zA-Z0-9_-]+" autocomplete="username" required>
                    </div>
                    <div class="option-group">
                        <label>Password</label>
                        <input id="password" type="password" minlength="8" maxlength="1024" autocomplete="new-password" required>
                    </div>
                    <div class="actions">
                        <button class="btn btn-primary" type="submit">Register</button>
                    </div>
                    <p id="auth-error" class="error-msg" style="display: none;"></p>
                </form>
                <p>Already have an account? <a href="/login">Log in</a></p>
            </main>
        </div>
    `;

    mountNav();
    const form = document.getElementById('register-form');
    form?.addEventListener('submit', async (e) => {
        e.preventDefault();
        const username = (document.getElementById('username') as HTMLInputElement).value;
        const password = (document.getElementById('password') as HTMLInputElement).value;
        const err = document.getElementById('auth-error');
        try {
            await register(username, password);
            window.location.href = '/';
        } catch (error) {
            if (err) {
                err.style.display = 'block';
                err.textContent = error instanceof Error ? error.message : 'Registration failed';
            }
        }
    });
}
